var map = {
	"./bank.webp": 479,
	"./campus.webp": 280,
	"./coding.webp": 527,
	"./jee.webp": 575,
	"./mpsc.webp": 186,
	"./police.webp": 667,
	"./rrb.webp": 617,
	"./ssc.webp": 568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;